import { Howl } from 'howler'

export default {
  appendPet: (state, { species, pet }) => {
    state[species].push(pet)
  },
  changeInstrument: (state, { instrument }) => {
    const newHowlSound = new Howl({
      src: [instrument],
      sprite: {
        do: [750 * 0 + 0, 750],
        re: [750 * 1 + 60, 740],
        mi: [750 * 2 + 60, 740],
        fa: [750 * 3 + 60, 740],
        sol: [750 * 4 + 60, 740],
        la: [750 * 5 + 60, 740],
        ti: [750 * 6 + 60, 740],
        doo: [750 * 7 + 60, 740]
      }
    })

    state.soundHelper.howlSound = newHowlSound
  }
}
